import {Component, OnInit} from '@angular/core';
import {ProfileService} from '../../../../provider/profile.service';
import {MenuAsideService} from '../../../../core/_base/layout';
import {Router} from '@angular/router';
import {RequestsService} from '../../../../provider/requests.service';

@Component({
  selector: 'kt-checkin-list',
  templateUrl: './checkin-list.component.html',
  styleUrls: ['./checkin-list.component.scss']
})
export class CheckinListComponent implements OnInit {
  loadPanel: {
    enabled: 'auto',
    height: 90,
    indicatorSrc: '',
    shading: false,
    shadingColor: '',
    showIndicator: true,
    showPane: true,
    text: 'Loading...',
    width: 200
  };
  loading = true;

  constructor(public myService: ProfileService,
              private menuAsideService: MenuAsideService,
              private route: Router,
              public requestService: RequestsService) {
    this.menuAsideService.pathname$.next(window.location.pathname);
    this.requestService.getOnlineRequest();
    this.requestService.check_in_request_change$.subscribe((datas) => {
      if (datas !== undefined) {
        this.loading = false;
      }
    });
  }

  ngOnInit() {
  }

  goProfile(value) {
    this.route.navigateByUrl('/activity/checkin-profiles/' + value);
  }
}
